import formBaseMongoMixin from  '../../../components/form/form-base-mongo'
import {calculationOffline} from "../../../api/api-offline-endpoints";
import regionalHelperMixin from './regional-helper-mixin'
import {NOTIFY} from "../../../config/config";

const moneyValidationPattern = '^(\\d*((\\.\\d{0,1}))?(\\d))$'

export default {
  mixins: [regionalHelperMixin, formBaseMongoMixin],
  data: () => ({
    tableErrors: {
      tariffs: null
    }
  }),
  destroyed () {
    this.clearTable()
  },
  mounted () {
    this.initFieldsAfterLoad()
  },
  methods: {
    recalcMVRatio (field = '') {
      let recalced = false
      switch (field) {
      case 'v_waste':
        if (!isNaN(this.fields.m_waste / this.fields.m_to_v_convert_ratio)) {
          this.$set(this.fields, 'v_waste', this.fields.m_waste / this.fields.m_to_v_convert_ratio)
          recalced = true
        }
        break
      case 'm_waste':
        if (!isNaN(this.fields.m_to_v_convert_ratio * this.fields.v_waste)) {
          this.$set(this.fields, 'm_waste', this.fields.m_to_v_convert_ratio * this.fields.v_waste)
          recalced = true
        }
        break
      case 'm_to_v_convert_ratio':
        if (!isNaN(this.fields.m_waste / this.fields.v_waste)) {
          this.$set(this.fields, 'm_to_v_convert_ratio', this.fields.m_waste / this.fields.v_waste)
          recalced = true
        }
        break
      }
      if (recalced === false) {
        this.$message({
          message: 'Заполненые не все поля, нужные для конвертации',
          type: 'error',
          duration: NOTIFY.ERROR_TIMEOUT
        })
      }
    },
    additionalValidate: async function (hasError = false, errors = {}) {
      await this.validateDataInTables(hasError, errors)
      return Promise.resolve(1)
    },
    afterPrepareFieldsForSend (fields = {}) {
      fields = this.putTablesDataToFieldsForSend(fields)
      // Расходы на обезвреживание и захоронение считаются след образом :
      // Сумма ((тариф+надбавка)*количество отходов)
      fields.burial_costs = 0
      fields.tariffs.forEach(item => {
        fields.burial_costs = (+item.tariff + +item.tariffSurcharge) * item.m_waste + fields.burial_costs
      })
      // Единый тариф считается так:
      // (собственные расходы + расходы на обезвреживание и захоронение)/количество отходов
      fields.tariff_result = 0
      fields.tariff_result = (+fields.own_expenses + +fields.burial_costs) / +this.fields.m_waste
      // by volume
      fields.tariff_result_volume = 0
      fields.tariff_result_volume = (+fields.own_expenses + +fields.burial_costs) / +this.fields.v_waste
      // round
      fields.tariff_result = fields.tariff_result.toFixed(3)
      fields.burial_costs = fields.burial_costs.toFixed(3)
      fields.tariff_result_volume = fields.tariff_result_volume.toFixed(3)
      return fields
    },
    update () {
      this.updateDataInTables()
      this.initFieldsAfterLoad()
    },
    initFieldsAfterLoad() {
      this.fields = Object.assign({}, this.item)
    }
  },
  computed: {
    tariffs () {
      return this.$store.getters.readUrlEndpoint(this.tariffsDataUrl).data
    },
    tariffsDataUrl () {
      return calculationOffline.tariffTable(this.$route.name)
    },
    enableOnAdd () {
      return []
    },
    tariffsAttributes () {
      return {
        operatorName: {
          label: 'Оператор',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        operatorObjectName: {
          label: 'Объекта оператора',
          validationRulePattern: '(\\.*)',
          placeholder: 'Введите название'
        },
        tariff: {
          label: 'Тариф',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00',
          required: true
        },
        tariffSurcharge: {
          label: 'Надбавка к тарифу',
          validationRulePattern: moneyValidationPattern,
          placeholder: '0.00'
        },
        v_waste: {
          label: 'V отходов (в куб. м.',
          required: true
        },
        m_waste: {
          label: 'M отходов (в тоннах) ',
          required: true
        }
      }
    },
    items () {
      return this.$store.getters.readUrlEndpoint(this.getItemsEndpoint(this.$route))
    }
  },
  asyncData ({store, route, fromRoute, methods}) {
    let promises = []

    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemsEndpoint(route, fromRoute)}))
    promises.push(store.dispatch('updateUrlEndpoint', {endpoint: methods.getItemEndpoint(route, fromRoute)}))

    if (promises.length === 0) {
      return Promise.resolve(1)
    }

    return Promise.all(promises)
  }
}
